import React from 'react';

const PILLS = ['£1,000/yr · Full platform for companies', '£0 · Free for advisors & investors', '3 days · To a certified Diligence Pack'];

const HomeWhatWeDo = () => (
    <section className="lp-ww-sec">
        <div className="lp-ww">
            <div className="lp-ww-eyebrow" data-lp-reveal>What we do</div>
            <h2 className="lp-h2" data-lp-reveal data-lp-delay="60" style={{ maxWidth: 720, margin: '0 auto 24px' }}>The platform that makes rigorous diligence viable for every SME transaction.</h2>
            <p className="lp-ww-body" data-lp-reveal data-lp-delay="120">Until now, thorough transaction diligence cost £40,000 and took months — making it unaffordable for the 70% of SME investments where it matters most. Diligentsia changes the economics entirely. Our AI platform reduces that process to days and £1,000 a year, giving companies the structured evidence investors need, giving advisors the tools to serve more clients at higher margins, and giving investors pre-qualified deal flow they can trust.</p>
            <div className="lp-ww-pills" data-lp-reveal data-lp-delay="180">
                {PILLS.map((p, i) => <span className="lp-ww-pill" key={i}>{p}</span>)}
            </div>
        </div>
    </section>
);

export default HomeWhatWeDo;
